import Vue from 'vue'
import App from './App.vue'
// import 'amfe-flexible';
import router from "./router"; // 引入路由
import { Toast } from 'vant';
import '@/assets/css/common.scss'
import './plugins/';
// 全局注册
// Vue.use(ImagePreview);
// Vue.use(Button);
Vue.use(Toast);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
